var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/chevron/Left/curved/32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron/Left/curved/32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2747844,24.9149313 C20.0964527,24.9149313 19.918121,24.849688 19.778452,24.7182348 L12.6843298,18.0411865 C12.2493744,17.6318452 12,17.0543211 12,16.4574657 C12,15.8606102 12.2493744,15.2830861 12.6843298,14.8737448 L19.778452,8.19669649 C20.0698721,7.9226746 20.5280251,7.93668983 20.8030135,8.22810993 C21.0775187,8.51953003 21.0635035,8.97816631 20.7716001,9.25315477 L13.6779612,15.9297198 C13.5305596,16.067939 13.4498513,16.2554531 13.4498513,16.4574657 C13.4498513,16.6594783 13.5305596,16.8469924 13.6779612,16.9852115 L20.7716001,23.6617766 C21.0635035,23.936765 21.0775187,24.3954013 20.8030135,24.6868214 C20.6604448,24.8385725 20.4676146,24.9149313 20.2747844,24.9149313",
    id: "Chevron-Left",
    fill: "#414052"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.c96753788e5ef327cd5bd1839a129294.svg";
export { ForwardRef as ReactComponent };